import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { styled } from "@mui/system";


const StyledDialog = styled(Dialog)(() => ({
    "& .MuiDialog-paper": { width: "500px", maxWidth: "90%" },
  }));


export const BaseDialog = ({
  open,
  onClose,
  title,
  message,
  onConfirm,
  confirmText,
  cancelText,
}) => {
  return (
    <StyledDialog open={open} onClose={onClose} aria-labelledby="custom-dialog-title">
      {title && <DialogTitle id="custom-dialog-title">{title}</DialogTitle>}
      <DialogContent>
        <DialogContentText style={{ whiteSpace: 'pre-line' }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
            {cancelText}
        </Button>
        <Button onClick={onConfirm} autoFocus>
          {confirmText}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};